import { render } from "./PanelAvisosForm.vue?vue&type=template&id=0bb3a428"
import script from "./PanelAvisosForm.vue?vue&type=script&lang=js"
export * from "./PanelAvisosForm.vue?vue&type=script&lang=js"
script.render = render

export default script